import { render } from "./DateTime.vue?vue&type=template&id=36a29d45&scoped=true"
import script from "./DateTime.vue?vue&type=script&lang=js"
export * from "./DateTime.vue?vue&type=script&lang=js"

import "./DateTime.vue?vue&type=style&index=0&id=36a29d45&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a29d45"]])

export default __exports__